import { useContext } from "react";

import MultiAuthContext from "./MultiAuthContext";

function useMultiAuth() {
  return useContext(MultiAuthContext);
}

export { useMultiAuth };
